var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconePerfil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline",
    transform: "translate(-3 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_34",
    "data-name": "Grupo 34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2277",
    "data-name": "Caminho 2277",
    d: "M19,3H14.82A2.988,2.988,0,0,0,9.18,3H5A2.006,2.006,0,0,0,3,5V19a2.006,2.006,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,19,3Zm-7-.25a.767.767,0,1,1-.55.25A.749.749,0,0,1,12,2.75ZM19,19H5V5H19Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2278",
    "data-name": "Caminho 2278",
    d: "M12,6a3,3,0,1,0,3,3A3.009,3.009,0,0,0,12,6Zm0,4a1,1,0,1,1,1-1A1,1,0,0,1,12,10Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2279",
    "data-name": "Caminho 2279",
    d: "M6,16.47V18H18V16.47c0-2.5-3.97-3.58-6-3.58S6,13.96,6,16.47ZM8.31,16A7.011,7.011,0,0,1,12,14.88,6.982,6.982,0,0,1,15.69,16Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconePerfil);
export default __webpack_public_path__ + "static/media/icone-perfil.1bdf468c54c04edac7c7e64fb8e8a3c9.svg";
export { ForwardRef as ReactComponent };